import {Repository} from '@/repositories/Base/Repository'

class MethodRepository extends Repository {
    endpoint = 'mapping/methods/table'

}

export default new MethodRepository()
